const data = [
    {
        name: "Prof. N R Mandal",
        position: "PRESIDENT",
        imageUrl: "/images/founder.webp",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Pradyun D",
        position: "GENERAL SECRETARY",
        imageUrl: "/assets/images/members/GB21/Pradyun D.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Tanishka Agarwal",
        position: "VICE PRESIDENT",
        imageUrl: "/assets/images/members/GB21/Tanishka Agarwal.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Chitranshu Ranjan",
        position: "ASSISTANT SECRETARY",
        imageUrl: "/assets/images/members/GB21/Chitranshu Ranjan.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Raunak Raj",
        position: "TREASURER",
        imageUrl: "/assets/images/members/GB21/Raunak Raj.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Goutam Mandal",
        position: "SCHOOL DEVELOPMENT OFFICER",
        imageUrl: "/assets/images/members/GB21/Goutam Mandal.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Nikhil Popli",
        position: "CHIEF FUNDRAISING OFFICER",
        imageUrl: "/assets/images/members/GB21/Nikhil Popli.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Nandini Jalan",
        position: "HOSTEL COMMITTEE OFFICER",
        imageUrl: "/assets/images/members/GB21/Nandini Jalan.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Prerit Jain",
        position: "CHIEF EXECUTIVE OFFICER, LiGHT",
        imageUrl: "/assets/images/members/GB21/Prerit Jain.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Devaki Nandana V V",
        position: "CHIEF EXECUTIVE OFFICER, PRAYAS",
        imageUrl: "/assets/images/members/GB21/Devaki Nandana Kalam.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Shivansh Sethi",
        position: "CHIEF EXECUTIVE OFFICER, RISE",
        imageUrl: "/assets/images/members/GB21/Shivansh Sethi.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Dhruv Singhal",
        position: "Corporate Relation Officer",
        imageUrl: "/assets/images/members/GB21/Dhruv Singhal.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Ravi Kumar Meena",
        position: "Social Strategy Development Officer, LiGHT",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Pratik Banka",
        position: "Public Relations Officer, LiGHT",
        imageUrl: "/assets/images/members/GB21/Pratik Banka.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Nitish Kumar",
        position: "HUMAN RESOURCE AND NETWORK MANAGEMENT OFFICER, LiGHT",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Shivam Pandey",
        position: "Chief Technical Officer",
        imageUrl: "/assets/images/members/GB21/Shivam Pandey.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Saurav Kumar Nishant",
        position: "Chief Advisory, Prayas",
        imageUrl: "/assets/images/members/GB21/Saurav Kumar Nishant.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Yash Raj Gupta",
        position: "Chief Advisory, Prayas",
        imageUrl: "/assets/images/members/GB21/Yash Raj Gupta.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
    {
        name: "Het Shah",
        position: "CHIEF ADVISORY",
        imageUrl: "/assets/images/members/GB21/Het Shah.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/"
    },
]

export default data;